import { Box, Typography } from '@mui/material';
import { NavLink, useLocation } from 'react-router-dom';

import { FORTA_BLUE } from '../../../utils/colors';

import type { MouseEvent } from 'react';

export const itemStyle = {
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  height: 24,
  justifyContent: 'flex-start',
  alignItems: 'center',
  padding: '24px 20px',
  borderRadius: 2,
  cursor: 'pointer',
  gap: 1.2,
  transition: 'all 0.3s ease-in-out',
  '&:hover': {
    backgroundColor: FORTA_BLUE.light1,
  },
};

interface NavItemProps {
  title: string;
  to: string;
  icon: {
    url: string;
    width: number;
    height: number;
  };
  iconStyle?: any;
  dataTestId?: string;
  isCollapsed: boolean;
}

const NavItem = (props: NavItemProps) => {
  const location = useLocation();
  const { title, to, icon, iconStyle, dataTestId, isCollapsed } = props;

  const activeStyle = {
    backgroundColor: FORTA_BLUE.light1,
  };

  const handleRouteChange = (e: MouseEvent, to: string) => {
    switch (to) {
      case '/treatment-plan':
        if (location.pathname.includes(to)) {
          e.preventDefault();
        }
        break;
    }
  };

  return (
    <NavLink
      data-testid={dataTestId}
      to={to}
      onClick={(e: MouseEvent) => handleRouteChange(e, to)}
      style={{
        textDecoration: 'none',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        margin: '20px 0px 20px 0px',
      }}
    >
      {({ isActive }) => (
        <Box
          sx={{
            ...itemStyle,
            justifyContent: 'flex-start',
            ...((isActive || (to === '/dashboard' && location.pathname === '/')) && activeStyle),
            ...{
              '& img': {
                ...iconStyle,
              },
            },
          }}
        >
          <img
            src={icon.url}
            alt="nav-icon"
            width={isCollapsed ? 30 : icon.width}
            height={isCollapsed ? 30 : icon.height}
            style={{
              transition: 'all 0.3s ease-in-out',
              marginLeft: isCollapsed ? '7px' : '-8px',
            }}
          />

          {!isCollapsed && (
            <Typography
              sx={{
                color: 'white',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                fontSize: '15px',
                fontWeight: isActive ? 700 : 400,
              }}
            >
              {title}
            </Typography>
          )}
        </Box>
      )}
    </NavLink>
  );
};

export default NavItem;
